/*
  Product card image carousel.

  Slide 0 is the card's existing primary image; slides 1..n are the extra
  images rendered by snippets/product-card.liquid. Arrows step through them
  and the progress bar tracks position.

  Delegated from document, so cards added later (pagination, infinite scroll,
  quick filters) work without re-initialising anything.
*/
(function () {
  'use strict';

  var FIGURE = '.product-card__figure.pcc-enabled';

  function slidesOf(figure) {
    return figure.querySelectorAll('.pcc-image');
  }

  function render(figure, index) {
    var extras = slidesOf(figure);
    var total = extras.length + 1;
    if (total < 2) return;

    // Wrap around in both directions.
    index = ((index % total) + total) % total;

    var primary = figure.querySelector('.product-card__image--primary');
    if (primary) primary.classList.toggle('pcc-primary-hidden', index !== 0);

    for (var i = 0; i < extras.length; i++) {
      extras[i].classList.toggle('active', i === index - 1);
      // Defer loading until a slide is actually reached.
      if (i === index - 1 && extras[i].dataset.src) {
        extras[i].src = extras[i].dataset.src;
        if (extras[i].dataset.srcset) extras[i].srcset = extras[i].dataset.srcset;
        delete extras[i].dataset.src;
        delete extras[i].dataset.srcset;
      }
    }

    var fill = figure.querySelector('.pcc-slider__fill');
    if (fill) {
      // The fill is one slot wide, so shifting it by whole multiples of its own
      // width lands it on each slot. Using transform rather than `left` keeps
      // the direction correct on this RTL storefront.
      fill.style.width = 100 / total + '%';
      fill.style.transform = 'translateX(' + index * 100 + '%)';
    }

    figure.dataset.pccIndex = String(index);
  }

  function step(figure, delta) {
    var current = parseInt(figure.dataset.pccIndex || '0', 10);
    render(figure, current + delta);
  }

  document.addEventListener(
    'click',
    function (event) {
      var arrow = event.target.closest('.pcc-arrow');
      if (!arrow) return;

      var figure = arrow.closest(FIGURE);
      if (!figure) return;

      // The card is wrapped in a link — never navigate when stepping images.
      event.preventDefault();
      event.stopPropagation();

      step(figure, arrow.classList.contains('pcc-arrow--left') ? -1 : 1);
    },
    true
  );

  // Reset a card back to its primary image once the pointer leaves it,
  // so the grid never looks half-browsed.
  document.addEventListener(
    'mouseleave',
    function (event) {
      var figure = event.target.closest && event.target.closest(FIGURE);
      if (figure && figure.dataset.pccIndex && figure.dataset.pccIndex !== '0') {
        render(figure, 0);
      }
    },
    true
  );
})();
